<template>
	<div class="tw-flex tw-h-screen tw-w-screen tw-animate-pulse">
		<!-- Navbar -->
		<div class="tw-w-96 md:tw-block tw-hidden tw-bg-primary-500 tw-p-4 tw-py-8 tw-pt-24">
			<div
				v-for="i of [1, 2, 3]"
				:key="i"
				class="tw-mb-8">
				<div class="tw-flex tw-gap-4">
					<div class="tw-w-8 tw-h-8 tw-bg-primary-100 tw-rounded-full" />
					<div class="tw-w-48 tw-h-8 tw-bg-primary-100 tw-rounded-full tw-flex-grow" />
				</div>
				<div
					class="tw-h-6 tw-bg-primary-50 tw-w-full tw-rounded-full tw-mt-4"
					v-for="j of [1, 2, 3, 4]"
					:key="j" />
			</div>
		</div>
		<!-- Page -->
		<div class="tw-bg-primary-50 tw-h-full tw-flex-grow">
			<!-- Header -->
			<div class="tw-h-16 tw-bg-primary-100 tw-flex tw-items-center tw-gap-4">
				<div class="tw-h-8 md:tw-w-48 tw-bg-primary-50 tw-ml-4 tw-rounded-full"></div>
				<div class="tw-ml-auto" />
				<div
					class="tw-h-8 tw-w-8 tw-bg-primary-200 tw-rounded-full"
					v-for="i of [1, 2, 3]"
					:key="i" />
				<div></div>
			</div>
			<!-- Content -->
			<div class="tw-p-8">
				<div class="tw-flex tw-gap-2">
					<div class="tw-w-1/2 tw-h-8 tw-bg-primary-200 tw-rounded-full"></div>
					<div class="tw-ml-auto tw-h-8 tw-w-8 tw-bg-primary-200 tw-rounded-full" />
				</div>
				<div class="tw-flex tw-gap-4">
					<div
						class="tw-mt-8 tw-w-1/3 tw-bg-primary-100 tw-h-48 tw-rounded-lg"
						v-for="i of [1, 2]"
						:key="i">
						<GraphSkeleton />
					</div>
				</div>
				<div class="tw-my-16" />
				<div class="tw-grid tw-grid-cols-4 tw-gap-4">
					<div class="tw-h-6 tw-w-full tw-rounded-full tw-bg-primary-400" />
					<div class="tw-h-6 tw-w-full tw-rounded-full tw-bg-primary-400" />
					<div class="tw-h-6 tw-w-full tw-rounded-full tw-bg-primary-400" />
					<div class="tw-h-6 tw-w-full tw-rounded-full tw-bg-primary-400" />
					<template
						v-for="i of [1, 2, 3, 4, 5]"
						:key="i">
						<div class="tw-ml-auto tw-h-4 tw-w-16 tw-bg-primary-200 tw-rounded-full" />
						<div class="tw-ml-auto tw-h-4 tw-w-32 tw-bg-primary-200 tw-rounded-full" />
						<div class="tw-ml-auto tw-h-4 tw-w-16 tw-bg-primary-200 tw-rounded-full" />
						<div class="tw-ml-auto tw-h-8 tw-w-8 tw-bg-primary-200 tw-rounded-full" />
					</template>
				</div>
			</div>
		</div>
	</div>
	<!-- <div id="sidebar" class="animate-400" data-include="navbar">
    <div class="menu" id="menu">
      <div class="mp0 ph2 mb4">
        <div class="w-100 h-2 br-04 bg-lightgrey-animated live op06"></div>
      </div>
      <ul class="navi mb4 tw-list-none">
        <li class="mp0 ph2 mb2">
          <div class="w-100 h-2 br-04 bg-lightgrey-animated live op06"></div>
        </li>
        <li class="mp0 ph2 mb1">
          <div class="w-100 h-1 br-04 bg-lightgrey-animated live op04"></div>
        </li>
        <li class="mp0 ph2 mb1">
          <div class="w-100 h-1 br-04 bg-lightgrey-animated live op04"></div>
        </li>
        <li class="mp0 ph2">
          <div class="w-100 h-1 br-04 bg-lightgrey-animated live op04"></div>
        </li>
      </ul>
      <ul class="navi tw-list-none">
        <li class="mp0 ph2 mb2">
          <div class="w-100 h-2 br-04 bg-lightgrey-animated live op06"></div>
        </li>
        <li class="mp0 ph2 mb1">
          <div class="w-100 h-1 br-04 bg-lightgrey-animated live op04"></div>
        </li>
        <li class="mp0 ph2 mb1">
          <div class="w-100 h-1 br-04 bg-lightgrey-animated live op04"></div>
        </li>
        <li class="mp0 ph2">
          <div class="w-100 h-1 br-04 bg-lightgrey-animated live op04"></div>
        </li>
      </ul>
    </div>
  </div>
  <div class="header animate-400" id="header" data-include="header">
    <div class="container-fluid h-100">
      <div class="row align-items-center h-100 ph2">
        <div class="col hidden-sm hidden-xs">
          <div class="breadcrumbs animate-400">
            <ul class="list-style-none list-inline" id="breadcrumbs">
              <li class="w-100">
                <div
                  class="w-100 maxw16 h-1 br-04 bg-lightblue-animated live op02"
                ></div>
              </li>
            </ul>
          </div>
        </div>
        <div class="col-auto">
          <ul
            class="list-icon list-icon-blank list-right"
            id="navi-button-list"
          >
            <li class="list-icon_item">
              <div class="w-2 h-2 br-100 br-04 tw-bg-primary-500 op02"></div>
            </li>
            <li class="list-icon_item">
              <div class="w-2 h-2 br-100 br-04 tw-bg-primary-500 op02"></div>
            </li>
            <li class="list-icon_item">
              <div class="w-2 h-2 br-100 br-04 tw-bg-primary-500 op02"></div>
            </li>
            <li class="list-icon_item">
              <div class="w-2 h-2 br-100 br-04 tw-bg-primary-500 op02"></div>
            </li>
            <li class="list-icon_item">
              <div class="w-2 h-2 br-100 br-04 tw-bg-primary-500 op02"></div>
            </li>
          </ul>
        </div>
      </div>
    </div>
  </div>
  <div id="main" class="animate-width-400">
    <div class="content vue-content-with-subnavi">
      <div class="container-fluid mb4">
        <div class="row align-items-center ph2">
          <div class="col col-md-6 col-lg-4">
            <div class="w-100 h-3 br-04 bg-lightgrey-animated live op04"></div>
          </div>
          <div class="col-auto col-md-1 col-lg-1">
            <div class="w-3 h-3 br-100 br-04 tw-bg-primary-500 op02"></div>
          </div>
        </div>
      </div>
      <div class="container-fluid">
        <div class="row align-items-top ph2">
          <div class="col-12 col-md-6 col-lg-4 mb2">
            <div class="w-100 bg-white br-04">
              <div class="ph2 pv2">
                <div class="container-fluid mp0">
                  <div class="row mb2">
                    <div class="col-12">
                      <div
                        class="w-100 h-1 br-04 bg-lightgrey-animated live op04"
                      ></div>
                    </div>
                  </div>
                  <div class="row mb3">
                    <div class="col-8">
                      <div
                        class="w-100 h-2 br-04 bg-lightblue-animated live op02"
                      ></div>
                    </div>
                    <div class="col-4">
                      <div
                        class="w-100 h-2 br-04 bg-lightblue-animated live op02"
                      ></div>
                    </div>
                  </div>
                  <div class="row">
                    <div class="col-12">
                      <div
                        class="w-100 h-1 br-04 mb1 bg-lightgrey-animated live op04"
                      ></div>
                      <div
                        class="w-100 h-1 br-04 mb1 bg-lightgrey-animated live op04"
                      ></div>
                      <div
                        class="w-100 h-1 br-04 bg-lightgrey-animated live op04"
                      ></div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="col-12 col-md-6 col-lg-8 col-xl-4 d-none d-md-block">
            <div class="w-100 bg-white br-04">
              <div class="ph2 pv2">
                <div class="container-fluid mp0">
                  <div class="row">
                    <div class="col-12">
                      <div class="w-100 h-1 br-04 bg-white op04"></div>
                      <div class="w-100 h-1 br-04 bg-white op04"></div>
                      <div
                        class="w-100 h-1 br-04 bg-lightgrey-animated live op04"
                      ></div>
                      <div class="w-100 h-1 br-04 bg-white op04"></div>
                      <div class="w-100 h-1 br-04 bg-white op04"></div>
                      <div class="w-100 h-1 br-04 bg-white op04"></div>
                    </div>
                  </div>
                  <div class="row mb3">
                    <div class="col-6">
                      <div
                        class="w-100 h-1 br-04 bg-lightblue-animated live op02"
                      ></div>
                    </div>
                    <div class="col-6">
                      <div
                        class="w-100 h-1 br-04 bg-lightblue-animated live op02"
                      ></div>
                    </div>
                  </div>
                  <div class="row">
                    <div class="col-12">
                      <div
                        class="w-100 h-1 br-04 mb1 bg-lightgrey-animated live op04"
                      ></div>
                      <div
                        class="w-100 h-1 br-04 bg-lightgrey-animated live op04"
                      ></div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="col-1">
            <div class="w-3 h-3 br-100 br-04 tw-bg-primary-500 op02"></div>
          </div>
        </div>
      </div>
    </div>
  </div> -->
</template>

<script setup lang="ts">
import GraphSkeleton from "@/components/views/Devices/Values/GraphSkeleton.vue";
</script>